import React from 'react';
import {
    List,
    ListSubheader,
    Divider,
    IconButton,
    Typography,
    Container,
    Box,
    TextField,
    InputAdornment,
    Checkbox,
    Button,
    Dialog,
    FormControl,
    InputLabel,
    Select,
    ListItem,
    MenuItem,
    Paper,
    ListItemIcon,
    ListItemText,
    Avatar,
} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { useSelector } from 'react-redux';
import { Close, Search, RotateLeft, CheckBox, Archive, CheckBoxOutlineBlank } from '@mui/icons-material';
import makeStyles from '@mui/styles/makeStyles';
import { isValidCharWithoutSpace } from '../../lib/site-helper';
import { TrendChannelSelectors } from '../../selectors/trend-channel-selectors';
// import { isTrendlineEnabled } from '../../state/dashboard-state';
import { Selectors } from '../../selectors';
import { mergeSimilarKeys } from '../../lib/trends-helpers';
import { isRecordFound, useSelectedOrganizationData } from '../../hooks/data-hooks';
import { useDeviceMaster } from '../../data/DataProviders/DeviceMasterProvider';
import { isDataLoaded } from '../../types';

const useStyles = makeStyles(() => ({
    root: {
        width: '420px',
    },
    TypoMessage: {
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '12px',
        lineHeight: '16px',
        display: 'flex',
        alignItems: 'center',
    },
    TypoMessage1: {
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '12px',
        lineHeight: '16px',
        //display: 'flex',
        marginTop: '10px',
        alignItems: 'center',
        textAlign: 'center',
    },
    TypoHeader: {
        color: '#007bc1',
        '& .MuiTypography-root': {
            marginTop: '20px',
        },
    },
    Typobody: {
        paddingLeft: '90px',
    },
    Container: {
        margin: '10px',
        padding: '10px',
        height: '100%',
        overflowX: 'hidden',
        '& .MuiFormControl-root': {
            marginBottom: '20px',
        },
    },
    formControl: {
        width: '98%',
        margin: '10px 10px 50px 0px',
    },
    Paper: {
        border: '1px solid grey',
        borderRadius: '10px',
        marginTop: '5px',
        height: '48%',
        overflow: 'auto',
        width: '98%',
        '&::-webkit-scrollbar': {
            width: '10px',
            borderRadius: '10px',
        },
        '&::-webkit-scrollbar-track': {
            boxShadow: 'inset 0 0 5px grey',
            borderRadius: '10px',
        },
        '&::-webkit-scrollbar-thumb': {
            background: 'grey',
            borderRadius: '10px',
        },
        listWrap: {
            '&:active': {
                borderRadius: '10px',
                background: 'black',
            },
        },
    },
}));

const StyledDialog = withStyles({
    root: {
        '& .MuiDialog-paper': {
            width: '500px',
            overflowX: 'hidden',
            height: '80%',
        },
    },
})(Dialog);

const SearchTextField = withStyles({
    root: {
        '& .MuiOutlinedInput-root': {
            borderRadius: '28px',
        },
    },
})(TextField);

export const TrendExportModal: React.FC<{
    open: boolean;
    onClose: Function;
    downloadCSV: Function;
    channels?: {
        maxTrendChannelToBeAllowedFromUser: number;
        trendChannels: Array<{ id: string; channelName: string; wasPriority: string | null }>;
    };
    deviceId?: string;
    isDevice: boolean | undefined;
    trends?: Array<{
        id: number;
        channelName: string;
        deviceId: string;
        deviceName: string;
        value: Array<{
            dateTime: string;
            value: string;
        }>;
        unit?: string | null | undefined;
    }>;
}> = (props) => {
    const { onClose, open } = props;
    const classes = useStyles();
    const [query, setQuery] = React.useState('');
    const [enableReset, setEnableReset] = React.useState(false);
    const [enableSelect, setEnableSelect] = React.useState(true);
    const trendChannels = useSelector(TrendChannelSelectors.selectedChannels);
    const [range, setRange] = React.useState<number>(1);
    const trendLinesEnabled = useSelector(Selectors.Dashboard.trendLinesEnabled);
    const deviceMasterData = useDeviceMaster();
    const selectedOrganization = useSelectedOrganizationData();
    const orgName = isRecordFound(selectedOrganization) ? selectedOrganization.value.name : '';
    const [displayChannels, setDisplayChannels] = React.useState<
        Array<{
            id: string;
            channelName: string;
            wasPriority?: string;
            deviceId: string;
            deviceName?: string;
            checked: boolean;
        }>
    >([]);
    const [channelsData, setChannelsData] = React.useState<
        Array<{
            id: string;
            channelName: string;
            wasPriority?: string;
            deviceId: string;
            deviceName?: string;
            checked: boolean;
        }>
    >([]);
    const [initialChannelsData, setInitialChannelsData] = React.useState<
        Array<{
            id: string;
            channelName: string;
            wasPriority?: string;
            deviceId: string;
            deviceName?: string;
            checked: boolean;
        }>
    >([]);
    const [deviceTypeList, setDeviceTypeList] = React.useState<any[]>([]);

    React.useEffect(() => {
        deviceMasterData.getTrendTimeInfo(orgName, 'all', 'trenddays');
    }, []); //eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        if (isDataLoaded(deviceMasterData.trendTimeInfo) && deviceMasterData.rowKey === 'trenddays') {
            setDeviceTypeList(deviceMasterData.trendTimeInfo.value);
        }
    }, [deviceMasterData]);

    const handleRangeChange = (event: any): void => {
        setRange(Number(event?.target.value));
    };

    const handleClose = (): void => {
        onClose();
    };

    const onChangeChannelName = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
        if (isValidCharWithoutSpace(e.target.value)) {
            setQuery(e.target.value);
        }
    };

    React.useEffect(() => {
        if (props.isDevice === true) {
            if (props.channels && props.deviceId !== undefined) {
                const dataWithChecked = props.channels.trendChannels.map((elem: any) => ({
                    ...elem,
                    checked: false,
                }));

                //let tempMainChannels: Array<{ id: string; channelName: string; wasPriority: string; checked: boolean }> = [];

                const tempMainChannels = dataWithChecked.map((item) => {
                    if (props.deviceId !== undefined) {
                        const foundRecord = trendChannels.find((x) => x.id.toString() === item.id);

                        if (foundRecord) {
                            // if (isTrendlineEnabled(trendLinesEnabled, Number(foundRecord.id), props.deviceId)) {
                            return { ...item, checked: true };
                            // }
                        }
                        return { ...item };
                    }
                });

                setChannelsData(tempMainChannels);
                setDisplayChannels(tempMainChannels);
                setInitialChannelsData(tempMainChannels);
                setEnableReset(false);
                setEnableSelect(true);
                setRange(1);
                setQuery('');
            }
        }
    }, [props.open, props.channels, trendChannels, trendLinesEnabled, props.deviceId]);

    React.useEffect(() => {
        if (props.isDevice === undefined && props.trends) {
            const dataWithChecked = props.trends.map((elem: any) => ({
                ...elem,
                checked: false,
            }));
            // let tempMainChannels: Array<{ id: string; channelName: string; checked: boolean }> = [];
            if (trendChannels.length > 0) {
                const tempMainChannels = dataWithChecked.map((item) => {
                    const foundRecord = trendChannels.find(
                        (x) => parseInt(x.id) === item.id && x.deviceId === item.deviceId
                    );
                    // console.log('foundRecord',foundRecord);
                    if (foundRecord) {
                        //if (isTrendlineEnabled(trendLinesEnabled, parseInt(foundRecord.id), item.deviceId)) {
                        return { ...item, checked: true };
                        //}
                    }
                    return { ...item };
                });
                setRange(1);
                setChannelsData(tempMainChannels);
                //console.log('temp',tempMainChannels);
                setDisplayChannels(tempMainChannels);
                setInitialChannelsData(tempMainChannels);
                setEnableReset(false);
                setEnableSelect(true);
                setQuery('');
            }
        }
    }, [props.open, props.channels, trendChannels]);

    const resetSearch = (): void => {
        setQuery('');
        setDisplayChannels(channelsData);
    };

    const resetSelection = (): void => {
        setQuery('');
        setDisplayChannels(initialChannelsData);
        setChannelsData(initialChannelsData);
        setEnableReset(false);
        setEnableSelect(true);
    };

    const selectAll = (): void => {
        if (props.isDevice === true) {
            if (props.channels && props.deviceId !== undefined) {
                setEnableSelect(false);
                const dataWithChecked = props.channels.trendChannels.map((elem: any) => ({
                    ...elem,
                    checked: true,
                }));
                setQuery('');
                setDisplayChannels(dataWithChecked);
                setChannelsData(dataWithChecked);
                setEnableReset(true);
            }
        } else {
            if (props.trends) {
                setEnableSelect(false);
                const dataWithChecked = props.trends.map((elem: any) => ({
                    ...elem,
                    checked: true,
                }));
                setQuery('');
                setDisplayChannels(dataWithChecked);
                setChannelsData(dataWithChecked);
                setEnableReset(true);
            }
        }
    };

    const searchResults = React.useCallback(
        (searchString: string): any[] => {
            const q = searchString.toLowerCase().trim();
            const tempData = channelsData.map((item: any) => ({ ...item }));
            return tempData.filter((item: any): boolean => {
                if (props.isDevice) {
                    if (
                        item.channelName
                            .toLowerCase()
                            .trim()
                            .includes(q)
                    ) {
                        return true;
                    }
                } else {
                    if (
                        item.channelName
                            .toLowerCase()
                            .trim()
                            .includes(q) ||
                        item.deviceName
                            .toLowerCase()
                            .trim()
                            .includes(q)
                    ) {
                        return true;
                    }
                }
                return false;
            });
        },
        [channelsData]
    );

    React.useEffect(() => {
        if (query !== '') {
            setDisplayChannels(searchResults(query));
        } else if (query === '') {
            setDisplayChannels(channelsData);
        }
    }, [query, searchResults]);

    const handleChange = (id: string, event: any, channel: any): void => {
        const newArr = displayChannels.map((obj) => {
            if (obj.id === id && obj.deviceId === channel.deviceId) {
                return { ...obj, checked: event.target.checked };
            }

            return obj;
        });
        const newData = channelsData.map((obj) => {
            if (obj.id === id && obj.deviceId === channel.deviceId) {
                return { ...obj, checked: event.target.checked };
            }

            return obj;
        });
        setDisplayChannels(newArr);
        setChannelsData(newData);
    };

    const handleExport = (): void => {
        if (props.isDevice) {
            onClose();
            const channels = channelsData.filter((item) => item.checked === true).map((obj) => obj.id);
            props.downloadCSV(channels, range);
        } else {
            onClose();
            const devices = channelsData.map(({ deviceId, id, checked }) => ({
                deviceId: deviceId,
                channelId: parseInt(id),
                check: checked,
            }));

            const selectedChannels = devices.filter((dp) => dp.check === true);
            const channels = mergeSimilarKeys(selectedChannels);
            props.downloadCSV(channels, range);
        }
    };

    //console.log('check',trendChannels);
    //console.log('check1',displayChannels);
    return (
        <StyledDialog
            onClose={(event: any, reason: string): void => {
                if (reason !== 'backdropClick') {
                    handleClose();
                }
            }}
            aria-labelledby="simple-dialog-title"
            open={open}
        >
            <List
                disablePadding
                subheader={
                    <ListSubheader
                        color="primary"
                        component="div"
                        style={{
                            fontWeight: 600,
                            display: 'flex',
                        }}
                    >
                        <Avatar style={{ margin: '5px 3px 0px 0px' }}>
                            <Archive style={{ height: 'auto' }} />
                        </Avatar>
                        Export Trendview Data
                        <IconButton
                            data-testid="close-model-button"
                            onClick={handleClose}
                            style={{ marginLeft: '225px' }}
                            size="large"
                        >
                            <Close fontSize="small" />
                        </IconButton>
                    </ListSubheader>
                }
            ></List>
            <Divider />
            <Container className={classes.Container}>
                <Typography variant="body2" className={classes.TypoMessage}>
                    Select the channels you&apos;d like to export
                </Typography>
                <div className={classes.TypoHeader}>
                    <Typography variant="subtitle2">Time Range</Typography>
                </div>
                <FormControl variant="filled" className={classes.formControl}>
                    <InputLabel id="demo-simple-select-filled-label">Time Range</InputLabel>
                    <Select
                        labelId="demo-simple-select-filled-label"
                        id="demo-simple-select-filled"
                        value={range}
                        onChange={handleRangeChange}
                        data-testid="time-range"
                    >
                        {isDataLoaded(deviceMasterData.trendTimeInfo) &&
                            deviceTypeList &&
                            deviceTypeList.length > 0 &&
                            deviceTypeList.map((item: any, index: number) => (
                                <MenuItem key={index} value={item.key} data-testid={`device-type-menu${index}`}>
                                    {item.value}
                                </MenuItem>
                            ))}
                    </Select>
                </FormControl>

                <Box>
                    <Typography variant="subtitle2" className={classes.TypoHeader} display="inline">
                        Channel Selection
                    </Typography>

                    <Typography variant="body2" className={classes.Typobody} display="inline">
                        <IconButton
                            onClick={resetSelection}
                            data-testid="reset-button"
                            style={{ paddingRight: '2px', fontSize: 'unset' }}
                            disabled={!enableReset}
                            size="large"
                        >
                            <RotateLeft fontSize="small" />
                            Reset selection
                        </IconButton>
                    </Typography>

                    <Typography variant="body2" display="inline">
                        <IconButton
                            onClick={selectAll}
                            data-testid="select-all-button"
                            style={{ paddingRight: '2px', fontSize: 'unset' }}
                            size="large"
                        >
                            {enableSelect ? <CheckBoxOutlineBlank fontSize="small" /> : <CheckBox fontSize="small" />}
                            Select All
                        </IconButton>
                    </Typography>
                </Box>
                {props.isDevice ? (
                    <SearchTextField
                        inputProps={{ 'data-testid': 'search', maxLength: 100 }}
                        style={{ width: '98%' }}
                        value={query}
                        data-testid="search-channel"
                        size="small"
                        placeholder={'Search Channel'}
                        onChange={(e): void => onChangeChannelName(e)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="end">
                                    <Search data-testid="search-icon" fontSize="small" />
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    {query !== '' && (
                                        <IconButton onClick={resetSearch} size="large">
                                            <Close fontSize="small" />
                                        </IconButton>
                                    )}
                                </InputAdornment>
                            ),
                        }}
                        variant="outlined"
                    />
                ) : (
                    <SearchTextField
                        inputProps={{ 'data-testid': 'search', maxLength: 100 }}
                        style={{ width: '98%' }}
                        value={query}
                        data-testid="search-channel"
                        size="small"
                        placeholder={'Search Channel Or Device Name'}
                        onChange={(e): void => onChangeChannelName(e)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="end">
                                    <Search data-testid="search-icon" fontSize="small" />
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    {query !== '' && (
                                        <IconButton onClick={resetSearch} size="large">
                                            <Close fontSize="small" />
                                        </IconButton>
                                    )}
                                </InputAdornment>
                            ),
                        }}
                        variant="outlined"
                    />
                )}

                {props.isDevice ? (
                    <Paper className={classes.Paper}>
                        <List className={classes.root}>
                            {displayChannels.length > 0 &&
                                displayChannels.map((channel: any) => {
                                    const labelId = `checkbox-list-label-${channel.id}`;
                                    return (
                                        <ListItem
                                            key={channel.id}
                                            role={undefined}
                                            data-testid={channel.id}
                                            dense
                                            button
                                        >
                                            <ListItemIcon style={{ minWidth: '30px' }}>
                                                <Checkbox
                                                    edge="start"
                                                    checked={channel.checked}
                                                    tabIndex={-1}
                                                    disableRipple
                                                    inputProps={{ 'aria-labelledby': labelId }}
                                                    onChange={(event): void => handleChange(channel.id, event, channel)}
                                                />
                                            </ListItemIcon>

                                            <ListItemText id={channel.id} primary={channel.channelName} />
                                        </ListItem>
                                    );
                                })}
                            {displayChannels.length === 0 && (
                                <Typography variant="h6" className={classes.TypoMessage1}>
                                    No Channel found
                                </Typography>
                            )}
                        </List>
                    </Paper>
                ) : (
                    <>
                        <Paper className={classes.Paper}>
                            <List className={classes.root}>
                                {displayChannels.length > 0 &&
                                    trendChannels.length > 0 &&
                                    displayChannels.map((channel: any) => {
                                        const labelId = `checkbox-list-label-${channel.id}`;
                                        return (
                                            <>
                                                <ListItem
                                                    key={channel.id}
                                                    role={undefined}
                                                    data-testid={channel.id}
                                                    dense
                                                    button
                                                >
                                                    <ListItemIcon style={{ minWidth: '30px' }}>
                                                        <Checkbox
                                                            edge="start"
                                                            checked={channel.checked}
                                                            tabIndex={-1}
                                                            disableRipple
                                                            inputProps={{ 'aria-labelledby': labelId }}
                                                            onChange={(event): void =>
                                                                handleChange(channel.id, event, channel)
                                                            }
                                                        />
                                                    </ListItemIcon>

                                                    <ListItemText
                                                        id={channel.id}
                                                        primary={channel.channelName}
                                                        secondary={channel.deviceName}
                                                    />
                                                </ListItem>
                                                <Divider />
                                            </>
                                        );
                                    })}
                                {displayChannels.length === 0 && (
                                    <Typography variant="h6" className={classes.TypoMessage1}>
                                        No Channel found
                                    </Typography>
                                )}
                            </List>
                        </Paper>
                    </>
                )}
            </Container>
            <Divider />
            <Box>
                <Button
                    style={{ margin: 12 }}
                    variant="outlined"
                    color="primary"
                    data-testid="close-model-button"
                    onClick={handleClose}
                >
                    Close
                </Button>
                <Button
                    style={{ float: 'right', margin: 12 }}
                    variant="contained"
                    color="primary"
                    data-testid="export-button"
                    onClick={handleExport}
                    disabled={!channelsData.some((item) => item.checked === true)}
                >
                    Export
                </Button>
            </Box>
        </StyledDialog>
    );
};
